import React, { Component } from 'react';
import styled from 'styled-components';
import Anchor from './ui/Controls/Anchor';

const MenuStyled = styled.div`
    & > nav {
        &.isMobileNav {
            z-index: 1;
            position: absolute;
            left: 0;
            background: #f1f1f1;
            top: 60px;
            width: 100%;
            height: 100vh;
            flex-direction: column;
            justify-content: start;
            & > div {
                margin-top: 10%;
            }
            & + label {
                display: block;
                margin-left: 75%;
            }
            & > div:not(:last-child) {
                a {
                    color: black;
                }
            }
            &.mobileNav--close {
                display: none;
            }
        }

        display: flex;
        justify-content: right;
        align-items: center;
        width: 80%;

        @media screen and (min-width: 768px) and (max-width: 1024px) {
            width: 100%;
        }
    }

    & .hamburger {
        border-bottom: 2px solid ${(props) => props.theme.colors.grey};
        width: 20px;
        height: 20px;
        position: relative;

        &:after,
        &:before {
            content: '';
            position: absolute;
            border: 1px solid ${(props) => props.theme.colors.grey};
            width: 90%;
            transition: transform 0.3s ease-in-out;
        }

        &:before {
            top: 5px;
        }
        &:after {
            top: 11.5px;
        }

        &--open {
            border: none;
            &:before {
                top: 11.5px;
                transform: rotate(-45deg);
            }
            &:after {
                transform: rotate(45deg);
            }
        }
    }

    @media screen and (min-width: 1024px) {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
`;

class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobileNav: false,
            isMobileNavOpen: false,
        };
    }

    componentDidMount() {
        this.removeActiveLinks();
        const path = window.location.pathname.replace(/\/$/, '');
        if (path !== '') {
            const currentPageLink = document.querySelectorAll(
                `[href="${path}"]`
            );
            // currentPageLink[0].parentElement.classList.add('active');
        }

        if (this.props.getWindowSize.width < 768) {
            this.setState({ isMobileNav: true });
        }
    }

    mobileNavToggle = (_) =>
        this.setState({ isMobileNavOpen: !this.state.isMobileNavOpen });

    removeActiveLinks = (_) => {
        let activeLink = document.querySelectorAll('.navMenu nav > div.active');
        if (Object.keys(activeLink).length !== 0) {
            activeLink[0].classList.remove('active');
        }
    };

    navItemClicked = (e) => {
        this.removeActiveLinks();
        e.currentTarget.parentNode.classList.add('active');
        this.setState({ isMobileNavOpen: false });
    };

    render() {
        const { className, getWindowSize, menuItems } = this.props;
        const nav =
            menuItems &&
            menuItems.map((item) => {
                // if (item?.menu_items?.menu_item_p?.href !== '/corn-bids') {
                return (
                    <Anchor
                        linkURL={item?.menu_items?.menu_item_p?.href}
                        key={item?.menu_items?._metadata?.uid}
                        text={item?.menu_items?.menu_item_p?.title}
                        className={
                            item?.menu_items?.menu_item_p?.title === 'Corn Bids'
                                ? 'header__nav--links'
                                : 'button button--secondary'
                        }
                        clickEvent={(e) => {
                            this.navItemClicked(e);
                        }}
                    ></Anchor>
                );
                // }
            });

        return (
            <MenuStyled className={`navMenu ${className}`}>
                <nav
                    className={`${
                        getWindowSize && getWindowSize.width < 768
                            ? this.state.isMobileNavOpen
                                ? 'isMobileNav mobileNav--open'
                                : 'isMobileNav mobileNav--close'
                            : ''
                    }`}
                >
                    {nav}
                </nav>
                {getWindowSize && getWindowSize.width < 768 ? (
                    <label
                        className={`hamburger ${
                            this.state.isMobileNavOpen ? 'hamburger--open' : ''
                        }`}
                        onClick={() => this.mobileNavToggle()}
                    ></label>
                ) : (
                    ''
                )}
            </MenuStyled>
        );
    }
}

export default Menu;
